export default __webpack_public_path__ + "static/media/brand2.5fd0cb09.png";